import React from 'react'
import { Modal } from 'react-bootstrap'
import { LDLItem, ElectricalCode } from '../Types'
import './Modal.scss'
import { simMod } from '../Module.config'
import { SecondaryButton, PrimaryButton } from '../styles/Buttons'

type Props = {
  ldlInfo: LDLItem
  show: any
  onHide: Function
  onAccept: Function
  electricalCode: ElectricalCode
}

const LDL: React.FC<Props> = ({ ldlInfo: { title, tableHeaders, steps }, onHide, onAccept, electricalCode, ...rest }: Props) => {

  const ldlHeaders = tableHeaders.map((header: string, idx: number) => {
    return (
      <th key={'ldlTh' + idx}>
        {header}
      </th>
    )
  })

  const ldlBody = steps.map((row: any, idx: number) => {
    return (
      <tr key={'ldlBody' + idx}>
        <td width={100}>{row.step}</td>
        <td width={500}>{row.test}</td>
        <td width={200}>{row.result[`${electricalCode.toLowerCase()}`]}</td>
      </tr>
    )
  })

  return (
    <Modal
      {...rest}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered={true}
      style={{ color: 'Black' }}
      className={'SimutechModal'}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          (simMod.solverModule.includes('LLTS') &&
            <p>{'You have successfully applied your lock and Do Not Operate tag.'}</p>
          ) ||
          (
            <table className={'LDL-table'}>
              <thead>
                <tr>
                  {ldlHeaders}
                </tr>
              </thead>
              <tbody>
                {ldlBody}
              </tbody>
            </table>
          )
        }
      </Modal.Body>
      <Modal.Footer>
        {
          (simMod.solverModule.includes('LLTS') &&
            <PrimaryButton onClick={() => onAccept()}>{'Close'}</PrimaryButton>
          ) ||
          (
            <>
              <SecondaryButton onClick={() => onHide()}>{`Leave Testing`}<br />{`Procedure`}</SecondaryButton>
              <PrimaryButton onClick={() => onAccept()}>{`Accept Test Results`}<br />{`And Continue Working`}</PrimaryButton>
            </>
          )
        }
      </Modal.Footer>
    </Modal>
  )
}
export default LDL